import LegalPage from "@/pages/LegalPage";

export default function Privacy() {
  return (
    <LegalPage title="Privacy Policy" testId="privacy-page">
      <p>
        This is a placeholder Privacy Policy for DriveAssure. It will describe how we collect, use and
        protect lesson data, GPS telemetry, and account information for instructors, learners and supervisors.
      </p>
      <p>
        DriveAssure records route and telemetry data only during active lessons and stores lesson records so
        instructors can export them and share progress reports. Full details will be published here.
      </p>
      <p>
        We do not sell personal data. Learners and supervisors control who their progress reports are shared with.
      </p>
    </LegalPage>
  );
}
